import React, {Component} from 'react';
import Table from 'react-bootstrap/Table';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

//cal rebre a través de props: resultatsCandidatures amb els valors escrits a continuació i partits



class TaulaCandidatures extends Component {	


    generaTaulaResultats(candidatura) {
        
        //Busquem si la candidatura està a la BD de partits
        var sigles = candidatura.sigles;
        var nomPartit;
        var color = null;

        this.props.partits.forEach(element => {
            if (element.codi_generalitat === candidatura.codi)  {
                sigles = element.sigles;
                nomPartit = element.nom;
                color = element.color;
            }
        });

        
        //Estructura de la taula de resultats de la candidatura
        return (  <tr>
                        {nomPartit &&
                        <td>
                            <span className="quadrat colorCandidatura" style={{backgroundColor: color}}></span>
                            <OverlayTrigger
                                key={"overlay_"+sigles}
                                placement={"top"}
                                overlay={
                                    <Tooltip id={`tooltip-${sigles}`}>
                                    {nomPartit}
                                    </Tooltip>
                                }
                                >
                                    <span className="textAmbOverlay"> {sigles}</span>
                                </OverlayTrigger>
                        </td>}

                        {!nomPartit &&
                        <td>
                            <span className="quadrat colorCandidatura" style={{backgroundColor: color}}></span> {sigles}
                        </td>}


                        <td>{candidatura.vots.toLocaleString('en').replace(/\,/g, '.')}</td>
                        <td>{candidatura.vots_per.toString().replace(/\./g, ',')}</td>
                        {(candidatura.escons>0) && <td><b>{candidatura.escons.toLocaleString('en').replace(/\,/g, '.')}</b></td>}
                     </tr>
        )
    }

    render() {          
     return (
        <Table striped bordered hover responsive variant="light" size="sm">
            <thead>
                <tr>
                    <th>Candidatura</th>
                    <th>Vots</th>
                    <th>%</th>
                    {(this.props.resultats.length>0&&this.props.resultats[0].escons>0) && <th>Escons</th>}
                </tr>
            </thead>                            
            <tbody>
                {this.props.resultats.map((candidatura)=>this.generaTaulaResultats(candidatura))}
            </tbody>
        </Table>
      );
    }
  }

  export default TaulaCandidatures;